import React from 'react';
import styles from "./Comment.module.sass"
import star from "../../../assets/star.png"

interface CommentProps {
    text: string
}

export const Comment: React.FC<CommentProps> = ({text}) => {
    return (
        <div className={styles.comment}>
            <span className={styles.comment__text}>{text}</span>
            <div className={styles.comment__starImgArrayWrap}>
                <div className={styles.comment__starImgArray}>
                    <img className={styles.star} src={star} alt=""/>
                    <img className={styles.star} src={star} alt=""/>
                    <img className={styles.star} src={star} alt=""/>
                    <img className={styles.star} src={star} alt=""/>
                    <img className={styles.star} src={star} alt=""/>
                </div>
            </div>
        </div>
    );
}
